module.exports = __webpack_public_path__ + "static/media/datos.ac29723a.svg";